import React from "react";
import { Global, css } from "@emotion/react";
import "normalize.css";

import { globalStyles } from "../assets/styles/globals";
import { heights, colors } from "../assets/styles/variables";
import Header from "./header";
import Footer from "./footer";

const layout = css`
  height: 100%;

  .container {
    height: calc(100% - (${heights.header} + ${heights.footer}));
    background-color: ${colors.blackThin};
  }
`;

const Layout = (props: any) => {
  const { sliderRef, length, parentArticleUrl, media, children } = props;
  return (
    <section css={layout}>
      <Global styles={globalStyles} />
      <Header parentArticleUrl={parentArticleUrl} media={media}/>
      <div className="container">{children}</div>
      <Footer sliderRef={sliderRef} length={length} />
    </section>
  );
};

export default Layout;
